import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const CustomTable = ({
  columns,
  loading,
  filteredData = [],
  rowActions,
  noDataMsg,
  onRowClick,
  searchQuery,
}) => {
  const { t } = useTranslation();
  const [selectedRow, setSelectedRow] = useState(null);

  const handleRowClick = (row, index) => {
    setSelectedRow(index);
    if (onRowClick) onRowClick(row);
  };

  return (
    <TableContainer component={Paper} sx={{ boxShadow: "none", mb: 2 }}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#fff" }}>
            {columns
              .filter((col) => col.field !== "otp")
              .map((column, index) => (
                <TableCell
                  key={index}
                  sx={{
                    fontWeight: 600,
                    color: "#555",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {column.title}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell
                colSpan={
                  columns.filter((col) => col.field !== "otp").length + 1
                }
                align="center"
              >
                <Typography sx={{ py: 2, color: "#777" }}>
                  {t("loading") || "Loading..."}
                </Typography>
              </TableCell>
            </TableRow>
          ) : filteredData?.length > 0 ? (
            filteredData.map((row, index) => (
              <TableRow
                key={index}
                hover
                onClick={() => handleRowClick(row, index)}
                selected={selectedRow === index}
                sx={{
                  cursor: "pointer",
                  "&.Mui-selected": {
                    backgroundColor: "rgba(230, 230, 250, 0.2)",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(230, 230, 250, 0.1)",
                  },
                  borderBottom: "1px solid #eee",
                }}
              >
                {columns.map((column, colIndex) => (
                  <TableCell
                    key={colIndex}
                    sx={{
                      py: 2,
                    }}
                  >
                    {column.render ? column?.render(row) : row?.[column.field]}
                  </TableCell>
                ))}
                {rowActions}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={
                  columns.filter((col) => col.field !== "otp").length + 1
                }
                align="center"
              >
                <Typography sx={{ py: 2, color: "#777" }}>
                  {searchQuery
                    ? t("no_results_found")
                    : noDataMsg ?? t("blank_message")}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTable;
